
import api from '~api'
import setting from '../../../server/settings'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

export default {
name: "delay",
components: {
XHeader,Group,Selector,XInput,Toast
},
data() {
return {
baseurl: setting.api_root+ '/api/greenchannel/imgLook?params=',
imageUrl1: "",
imageUrl2: "",
title: "建档立卡",
stuinfo:{
},
state:0,
reduceinfo:{




},
reduce:{
applyMoney:this.$route.params.tmp
},
showtoast:false,
toasttext:'',
relations: [{
key: '1',
value: '建档立卡'
}],
}
},
mounted(){

api.post("/api/NewReports/findInformation", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.status==200){
this.stuinfo = res.data.results[0];
if(this.stuinfo.gender=="1"){
this.$set(this.stuinfo,"sex","男")
}else{
this.$set(this.stuinfo,"sex","女")
}
}
})
this.getData()

},
methods:{
choosePhoto(file){
var _this = this;
var event = event || window.event;
var file = event.target.files[0];
var reader = new FileReader();

reader.onload = function(e) {
_this.imageUrl1 = e.target.result 
}
reader.readAsDataURL(file);

},
choosePhoto1(file){
var _this = this;
var event = event || window.event;
var file = event.target.files[0];
var reader = new FileReader();

reader.onload = function(e) {
_this.imageUrl2 = e.target.result 
}
reader.readAsDataURL(file);

},
getData(){
api.post("/api/greenchannel/selectStuJdlkMsg", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data.code == 0){
if(res.data.msg=="null"){
this.$msgbox('温馨提示：', "建档立卡缓交金额为学费+住宿费-12000！");
this.$vux.loading.hide();
this.state = 0;
}else{
this.reduceinfo = res.data.msg;
this.state = 2;
}
}
})
},
checkRel(){
if(this.reduce.type == '' || this.reduce.type ==null){
this.toasttext = "请选择缓交类型";
this.showtoast=true;
return false;
}
return true;
},
checknum(){
var numreg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
if(this.reduce.applyMoney == '' || this.reduce.applyMoney ==null){
this.toasttext = "请输入缓交金额！";
this.showtoast=true;
return false;
}else if (!numreg.test(this.reduce.applyMoney) || parseFloat(this.reduce.applyMoney)<0 ){
this.toasttext = "请输入有效的缓交金额！";
this.showtoast=true;
return false;
}else if(parseFloat(this.reduce.applyMoney)>this.$route.params.tmp){
this.toasttext = "缓交金额须小于住宿费与学费的总和！";
this.showtoast=true;
return false;
}
return true;
},
goedit(){
if(this.checknum() && this.checkRel()){
if(this.imageUrl1 == "" || this.imageUrl2 == ""){
this.toasttext = "照片不能为空！";
this.showtoast=true;
}else{
this.$vux.loading.show({
text: '加载中，请稍候！'
})
var param = {
'applyMoney': this.reduce.applyMoney,
'stuCode': window.localStorage.getItem("stuCode"),
'applyHouseholderBaese64': this.imageUrl1,
'applyOneselfBaese64': this.imageUrl2,
'idCard': this.stuinfo.idCard
};
api.post("/api/greenchannel/saveStuJdlkMsg", param).then( res=>{
if(res.data.code == 0){
var stunum = this.$route.params.stunum;































this.$router.push({name:'onlinefee',params:{stunum:stunum}})
}else{
this.$msgbox('温馨提示：',"建档立卡申请失败!");
}
this.$vux.loading.hide()
})
}
}
},
deleteApply(){
this.$vux.loading.show({
text: '加载中，请稍候！'
})
api.post("/api/greenchannel/delete", {"applyType":this.reduceinfo.applyType,"typeId":this.reduceinfo.typeId,"verifyId":this.reduceinfo.verifyId}).then( res=>{
console.log(res.data)
console.log(res.data.code)
if(res.data.code == 0){
this.$router.push({name:'onlinefee',params:{stunum:this.$route.params.stunum}})
}else{
this.$msgbox('温馨提示：',"撤回失败！");
}
this.$vux.loading.hide()
})
},
reedit(){
this.state = 0;
this.reduceinfo.applyStatus = '';
}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/reduce.vue